import { render } from "./DeleteIcon.vue?vue&type=template&id=523b7de2&scoped=true&bindings={}"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts"

import "./DeleteIcon.vue?vue&type=style&index=0&id=523b7de2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-523b7de2"

export default script